export enum HorizontalCardColorVariants {
  Default = "default",
  PrimaryTitle = "primary-title",
  PrimaryBackground = "primary-background",
}

export enum HorizontalCardTitleSize {
  Large = "large",
  Medium = "medium",
  Small = "small",
}
